import gql from 'graphql-tag';

export const getCropListQuery = () => ({
  query: gql`
    query getCropList {
      crops(displayCrop: true, itemStatus: ACTIVE) {
        nodes {
          id
          name
          breedingMethod
          updatedAt
          cropLegacyIds {
            cropCode
            id
            uuid
          }
          nominalWeight {
            u: unit
            q: value
          }
          nominalMoisture {
            u: unit
            q: value
          }
        }
      }
    }
  `
});
